module.exports = __webpack_public_path__ + "4f26f363fa9c69b450cd563f2dbd0af8.pdf";